/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IChooseVnoModalScope extends ng.IScope {
        title: string;
        currentVnos: Models.Vno[];
        vnos: Models.Vno[];
        selected: {
            vno: Models.Vno
        };
        modalClose: () => void;
        modalSave: () => void;
        currentVnosText: () => string;
    }

    export class ChooseVnoModalController {
        public static templateUrl: string = "decorators/modals/choose-vno-modal.html";
        public static id: string = "#choose-vno-modal";
        public static $name: string = "chooseVnoModalController";
        public static $inject: string[] = ['$scope', 'close', 'title', 'vnos', 'currentVnos'];

        private scope: IChooseVnoModalScope;
        private close: (result: Models.Vno) => void;
        
        constructor($scope: IChooseVnoModalScope,
                    close: () => void,
                    title: string,
                    vnos: Models.Vno[],
                    currentVnos: Models.Vno[]) {
            this.scope = $scope;
            this.close = close;
            this.scope.title = title;
            this.scope.vnos = vnos;
            this.scope.selected = { vno: undefined };
            if ( currentVnos.length > 0 ) {
                for (let vno of vnos) {
                    if (currentVnos[0].id === vno.id) {
                        this.scope.selected = { vno: vno };
                    }
                }
            }


            this.scope.modalSave = () => {
                if (this.scope.selected.vno !== undefined) {
                    this.close(this.scope.selected.vno);
                } else {
                    this.close(undefined);
                }
            };

            this.scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.scope.currentVnosText = (): string => {
                let text: string =  currentVnos.length > 1 ? "Current VNOs: " : "Current VNO: ";
                text += currentVnos.map((vno: Models.Vno) => {
                    return vno.name;
                }).join(", ");
                return text;
            };
        }
    }
}
